import * as React from 'react';
import { isScrollLocked } from './scroll-lock.js';

const useHeaderOnScroll = (isMobile)=>{
    const [isHidden, setIsHidden] = React.useState(false);
    const [isCondensedHeader, setIsCondensedHeader] = React.useState(false);
    const headerRef = React.useRef(null);
    const lastScrollTop = React.useRef(0);
    const headerHeight = React.useRef(0);
    /**
   * Scroll handler toggling header visibility on mobile
   */ const handleScroll = React.useCallback(()=>{
        const threshold = 10;
        const scrollTop = window.pageYOffset;
        // Check if we passed the threshold, or if the scroll is currently locked before we do anything
        if (Math.abs(lastScrollTop.current - scrollTop) <= threshold || isScrollLocked()) {
            return;
        }
        setIsHidden(scrollTop > lastScrollTop.current && scrollTop > headerHeight.current);
        lastScrollTop.current = scrollTop;
    }, [
        setIsHidden
    ]);
    /** Adds scroll listener to header */ React.useEffect(()=>{
        if (isMobile) {
            if (headerRef.current) {
                headerHeight.current = headerRef.current.offsetHeight;
            }
            window.addEventListener('scroll', handleScroll);
        }
        return ()=>window.removeEventListener('scroll', handleScroll)
        ;
    }, [
        isMobile,
        handleScroll
    ]);
    React.useEffect(()=>{
        if (!isMobile) {
            const handleDesktopScroll = ()=>setIsCondensedHeader(window.pageYOffset > 50)
            ;
            handleDesktopScroll();
            window.addEventListener('scroll', handleDesktopScroll);
            return ()=>window.removeEventListener('scroll', handleDesktopScroll)
            ;
        }
    }, [
        isMobile
    ]);
    return React.useMemo(()=>({
            isHidden,
            isCondensedHeader,
            headerRef
        })
    , [
        isHidden,
        isCondensedHeader,
        headerRef
    ]);
};

export { useHeaderOnScroll };
//# sourceMappingURL=use-header-on-scroll.js.map
